import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';
import { ModalCancelarComponent } from 'src/app/shared/components/modal-cancelar/modal-cancelar-component';
import { CategoriaRiscoFormComponent } from 'src/app/pages/categoria-risco-form/categoria-risco-form.component';

@Injectable()
export class CategoriaRiscoGuard implements CanDeactivate<CategoriaRiscoFormComponent> {
  canDeactivate(component: CategoriaRiscoFormComponent): Observable<boolean> | boolean {
    if (component.novoRegistro) {
      if (component.submit) { return true; }
      return component.matDialog.open(ModalCancelarComponent).afterClosed();
    } else { return true; }
  }
}
